import PropTypes from 'prop-types';
import React from 'react';
import FeedArticle from '../FeedArticle';
import articlePropType from '../../propTypes/article';

const PromoCards = ({ promoBoxCards, doTrackFeed }) => (
  <div className="sl-promobox-cards">
    {promoBoxCards.map((article, index) => (
      <FeedArticle
        article={article}
        doTrackFeed={doTrackFeed}
        key={article.id}
        type="promo"
        promoPosition={index + 7}
      />
    ))}
  </div>
);

PromoCards.propTypes = {
  doTrackFeed: PropTypes.func.isRequired,
  promoBoxCards: PropTypes.arrayOf(articlePropType).isRequired,
};

export default PromoCards;
